/**
 * Whether this build publishes the `actor-synced` / `actor-sync-diag` accessibility sentinels
 * (`SyncStatusSentinel`). They exist for the staging Maestro suite. Store builds leave them out:
 * VoiceOver and TalkBack would otherwise read "actor-sync-diag phase=…" to real users on every
 * screen.
 */
export const IS_SYNC_STATUS_SENTINEL_PUBLISHED = process.env.EXPO_PUBLIC_APP_VARIANT !== "production";
